import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AppLayout } from '@/components/layout/AppLayout';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { PlaylistsPage } from '@/pages/PlaylistsPage';
import { PlaylistDetailPage } from '@/pages/PlaylistDetailPage';
import { LiveSessionPage } from '@/pages/LiveSessionPage';
import { LiveFeedPage } from '@/pages/LiveFeedPage';
import { EditProfilePage } from '@/pages/EditProfilePage'; // New Route
import { ThemeProvider } from '@/contexts/ThemeContext'; // New Provider
import { AdminPage } from '@/pages/AdminPage';
import { AdminRoute } from '@/components/auth/AdminRoute';
import { ToastContainer } from 'react-toastify';
import { queryClient } from '@/lib/queryClient';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />

              {/* Protected Routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <AppLayout>
                    <DashboardPage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/profile" element={
                <ProtectedRoute>
                  <AppLayout>
                    <ProfilePage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/profile/edit" element={
                <ProtectedRoute>
                  <AppLayout>
                    <EditProfilePage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/playlists" element={
                <ProtectedRoute>
                  <AppLayout>
                    <PlaylistsPage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/playlists/:id" element={
                <ProtectedRoute>
                  <AppLayout>
                    <PlaylistDetailPage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/live" element={
                <ProtectedRoute>
                  <AppLayout>
                    <LiveFeedPage />
                  </AppLayout>
                </ProtectedRoute>
              } />

              <Route path="/playlists/:id/live" element={
                <ProtectedRoute>
                  <LiveSessionPage />
                </ProtectedRoute>
              } />

              <Route path="/settings" element={
                <ProtectedRoute>
                  <AppLayout>
                    <SettingsPage />
                  </AppLayout>
                </ProtectedRoute>

              } />

              {/* Admin Routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={
                  <AppLayout>
                    <AdminPage />
                  </AppLayout>
                } />
              </Route>

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ToastContainer position="top-center" />
            <ReactQueryDevtools initialIsOpen={false} />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter >
  );
}

export default App;
